<template>
  <!--  노션 링크 : https://www.notion.so/RestaurantPage-855bfff665974a9fb53371a6d302759e -->
  <div>
    <PopupPage :subtitle1="3" />
    <div>
      <breadcrumb :breadcrumb_link="restaurant_breadcrumb" />
    </div>
    <div class="header">
      <h1 class="overlay">RESTAURANT</h1>
      <!--      <img src="@/assets/images/Podohotel/about_headerimage.jpg" />-->
      <div class="headerimage" />
    </div>

    <div :class="{jpword: isLang === 2}">
      <div :class="{anotherword: isLang === 0 || isLang === 1}">
        <div class="contentDesc">
          <div class="title1">
            <h2>
              <strong>{{ $t('restaurant_title') }}</strong>
            </h2>
          </div>
          <div class="title2">
            <h4>{{ $t('restaurant_subtitle') }}</h4>
          </div>
          <div class="title3">
            <p>{{ $t('restaurant_desc') }}</p>
          </div>
        </div>

        <GallerySlideCarousels :slides="slides" :slide-count="4" :thumb-slide-width="50" />

        <div class="container">
          <div class="container" v-show="isLang === 0">
            <div class="row d-flex justify-content-center mt-5 mb-5">
              <h1>SIGNATURE MENU</h1>
            </div>
            <div class="row d-flex justify-content-center">
              <!--          <Dining :show-signature-mode="true" />-->
              <!-- 시그니처메뉴 static으로 수정-->
              <div class="row d-flex justify-content-center">
                <div class="card-deck">
                  <div class="card">
                    <img
                      class="card-img-top"
                      src="@/assets/images/Golf/restaurant_signaturemenu_image21.jpg"
                      alt="Card image cap"
                      style="padding: 10px"
                    />
                    <div class="card-body">
                      <h5 class="card-title">제주 고사리 육개장</h5>
                      <p class="text-narrow card-text">매콤한 양념에 숙성시킨 제주 고사리를 사골 육수에 끓여낸 음식</p>
                    </div>
                  </div>
                  <div class="card">
                    <img
                      class="card-img-top"
                      src="@/assets/images/Golf/restaurant_signaturemenu_image26.jpg"
                      alt="Card image cap"
                      style="padding: 10px"
                    />
                    <div class="card-body">
                      <h5 class="card-title">제주 반상</h5>
                      <p class="sig-card-text card-text">
                        돌문어 무침, 흑돼지 수육 등 제주의 맛을 한상에 담아낸 핀크스 반상
                      </p>
                    </div>
                  </div>
                  <div class="card">
                    <img
                      class="card-img-top"
                      src="@/assets/images/Golf/restaurant_signaturemenu_image22.jpg"
                      alt="Card image cap"
                      style="padding: 10px"
                    />
                    <div class="card-body">
                      <h5 class="card-title">제주 튀김</h5>
                      <p class="card-text">신선한 제주 한치와 멜(멸치), 고추를 바삭하게 튀겨낸 요리</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <table class="table table-borderless mt-5 mb-5">
            <tbody>
              <tr>
                <td>{{ $t('restaurant_table_td1') }}</td>
                <td>{{ $t('restaurant_table_td2') }}</td>
              </tr>
              <tr>
                <td style="vertical-align: middle">{{ $t('restaurant_table_td3') }}</td>
                <td v-html="$t('restaurant_table_td4')"></td>
              </tr>
              <tr>
                <td>{{ $t('restaurant_table_td5') }}</td>
                <td>
                  <a target="_blank" :href="morningMenuFileLink" class="res-button">{{ $t('restaurant_table_td6') }}</a>
                  <a target="_blank" :href="launchMenuFileLink" class="res2-button">{{ $t('restaurant_table_td7') }}</a>
                </td>
              </tr>
              <tr>
                <td>{{ $t('restaurant_table_td8') }}</td>
                <td>{{ $t('restaurant_table_td9') }}</td>
              </tr>
              <tr>
                <td>{{ $t('restaurant_table_td10') }}</td>
                <td>{{ $t('restaurant_table_td11') }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!--    추천메뉴 & 프로모션 : 메뉴가 없으므로 일단 히든-->
    <div class="container" v-show="isLang === 0">
      <div class="dining">
        <div class="py-5 d-flex justify-content-center">
          <h1>추천메뉴 & 프로모션</h1>
        </div>
        <DiningPromotion />
      </div>
    </div>
  </div>
</template>

<script>
import GallerySlideCarousels from '@/components/GallerySlideCarousels';
import Breadcrumb from '@/components/Breadcrumb';
// import Recommenddining from '@/pages/Dining/Components/Recommenddining';
// import Dining from '@/pages/MainPage/Components/Dining';
import boardService, {BoardParam} from '@/services/board.service';
import {BOARD_ID} from '@/util/BoardConst';
import DiningPromotion from '@/pages/MainPage/Components/DiningPromotion';
import PopupPage from '@/pages/Popup/PopupPage.vue';

export default {
  name: 'RestaurantPage',
  data() {
    return {
      restaurant_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'DINING',
        present: this.$t('breadcrumb'),
      },
      slides: [
        {image: require('@/assets/images/Golf/restaurant_bodyimage01.jpg')},
        {image: require('@/assets/images/Golf/restaurant_bodyimage02.jpg')},
        {image: require('@/assets/images/Golf/restaurant_bodyimage03.jpg')},
        {image: require('@/assets/images/Golf/restaurant_bodyimage04.jpg')},
      ],
      index: 0, // default: 0,
      morningMenuFileLink: '',
      launchMenuFileLink: '',
      isLang: 0,
    };
  },
  mounted() {
    this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
  },
  components: {
    GallerySlideCarousels,
    Breadcrumb,
    DiningPromotion,
    PopupPage,
    // Dining,
    // Recommenddining,
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }

      this.restaurant_breadcrumb = {
        toplink: 'HOME',
        prevlink: 'DINING',
        present: this.$t('breadcrumb'),
      };

      this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  async created() {
    let p = new BoardParam();
    p.aProjection = 'BoardArticleDetailWithFiles';
    p.bid = BOARD_ID.BID_GOLF_RESTAURANT_MENU;
    p.subtitle1Search = '조식메뉴';
    let result = await boardService.getArticleListObjParamFirst(p);
    if (result) this.morningMenuFileLink = result.getFirstAttachFileUrl(false);

    p.subtitle1Search = '중석식메뉴';
    let result2 = await boardService.getArticleListObjParamFirst(p);
    if (result2) this.launchMenuFileLink = result2.getFirstAttachFileUrl(false);

    this.refreshLocale(this.$i18n.locale);
  },
};
</script>

<style scoped lang="scss">
.jpword {
  word-break: break-all;
}
.anotherword {
  p,
  h1,
  h2,
  h3,
  h4,
  h5 {
    word-break: keep-all;
  }
}
.sig-card-text {
  letter-spacing: -0.2px;
  word-break: keep-all;
}

.card-title {
  font-weight: bold;
}

.card-text {
  padding-left: 0;
}

.overlay {
  color: White;
  position: absolute;
  z-index: 12;
  top: 30%;
  left: 0;
  width: 100%;
  text-align: center;
}

.header {
  position: relative;
  width: 100%;
  > img {
    width: 100%;
  }

  .overlay {
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }
}

.contentDesc {
  text-align: center;

  .title1 {
    margin-top: 3rem;
  }

  .title2 {
    margin-top: 3rem;
  }

  .title3 {
    margin-top: 1rem;
    margin-bottom: 5rem;
  }
}
.Banquethall_breadcrumb {
  margin-top: 130px;
}

.Banquethall_body_hedaer {
  margin-top: 40px;
  margin-bottom: 50px;
}

.overlay {
  color: White;
  position: absolute;
  z-index: 12;
  top: 30%;
  left: 0;
  width: 100%;
  text-align: center;
}
td {
  border-bottom: 1px dashed #cdcdcd;
}

@media (max-width: 992px) {
  .main-ex-img {
    margin-bottom: 50px;
  }
  .main-ex-desc {
    vertical-align: center;
    text-align: center;
  }
  .headerimage {
  }
  .header {
    position: relative;
    width: 100%;
    padding-top: 5rem;
    > img {
      width: 100%;
    }

    .overlay {
      padding-top: 5rem;
      color: White;
      position: absolute;
      text-align: center;
      z-index: 12;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: lighter;
      letter-spacing: -0.1rem;
    }
  }

  h1 {
    font-size: 1.6rem !important;
    font-weight: 600;
  }

  h4 {
    font-size: 1.2rem !important;
    font-weight: 600;
    padding: 0 1rem;
  }

  h3 {
    font-size: 1.2rem !important;
    font-weight: 600;
  }
  p {
    font-size: 0.9rem !important;
    padding: 0 1rem;
  }
  .dining {
    min-height: 10rem;
  }
  div {
    font-size: 0.9rem !important;
  }
}
@media (min-width: 992px) {
  .main-ex-desc {
    vertical-align: bottom;
  }
  .headerimage {
    width: 100%;
    margin: 0;
    content: url('~@/assets/images/Golf/restaurant_headerimage.jpg');
  }
}
.restaurant_body_hedaer {
  margin-top: 40px;
  margin-bottom: 50px;
  td {
    border-bottom: 1px dashed #cdcdcd;
  }
}
.res-button {
  position: relative;
  display: inline-block;
  padding: 8px 22px;
  font-size: 15px;
  background-color: #524a3d;
  color: #fff;
  margin-right: 5px;
}
.res2-button {
  position: relative;
  display: inline-block;
  padding: 8px 22px;
  font-size: 15px;
  background-color: #524a3d;
  color: #fff;
}
</style>

<i18n>
{
  "ko": {
    "breadcrumb": "레스토랑",
    "restaurant_title": "레스토랑",
    "restaurant_subtitle": "자연이 함께 하는 즐거운 만남",
    "restaurant_desc": "골프코스와 오름, 바다가 한데 어우러지는 드라마틱한 풍경, 창가에 앉으면 자연이 만들어내는 사계절의 아름다운 전경이 눈앞에 펼쳐집니다.",
    "restaurant_table_td1": "위치",
    "restaurant_table_td2": "클럽하우스",
    "restaurant_table_td3": "운영시간",
    "restaurant_table_td4": "일~목요일: 06:00~15:00 (Last Order 14:30)<br/>금~토요일: 06:00~17:30 (Last Order 16:30)",
    "restaurant_table_td5": "메뉴",
    "restaurant_table_td6": "조식",
    "restaurant_table_td7": "중·석식",
    "restaurant_table_td8": "규모",
    "restaurant_table_td9": "총 68석 / 최대 120석 (*인원 초과 시 개별 문의)",
    "restaurant_table_td10": "문의",
    "restaurant_table_td11": "064-793-5030"
  },

  "en":{
    "breadcrumb": "RESTAURANT",
    "restaurant_title": "RESTAURANT",
    "restaurant_subtitle": "Exciting meeting in nature",
    "restaurant_desc": "The dramatic scenery made of the golf course and oreum (volcanic cone) and the beautiful scenery of the four seasons created by nature will spread before you when you sit by the window.",
    "restaurant_table_td1": "Location",
    "restaurant_table_td2": "Club House",
    "restaurant_table_td3": "Opening Hours",
    "restaurant_table_td4": "Sunday – Thursday : 06:00 – 15:00 (Last Order 14:30)<br/>Friday – Saturday : 06:00 – 17:30 (Last Order 16:30)",
    "restaurant_table_td5": "Menu",
    "restaurant_table_td6": "Breakfast",
    "restaurant_table_td7": "Lunch & Dinner",
    "restaurant_table_td8": "Seat",
    "restaurant_table_td9": "68 seats / 120 seats maximum (Inquire separately for an excessive number of people)",
    "restaurant_table_td10": "Reservation & Inquiry",
    "restaurant_table_td11": "+82-64-793-5030"
  },

  "ja": {
    "breadcrumb": "レストラン",
    "restaurant_title": "レストラン",
    "restaurant_subtitle": "自然の中の楽しい出会い",
    "restaurant_desc": "ゴルフコースとオルム、海が調和するドラマチックな風景、窓辺に座ると自然が織りなす四季折々の美しい景色が目の前に広がります。",
    "restaurant_table_td1": "位置",
    "restaurant_table_td2": "クラブハウス",
    "restaurant_table_td3": "営業時間",
    "restaurant_table_td4": "朝食はティーオフの20分前より注文を受け付け、事前予約により調整可能",
    "restaurant_table_td5": "メニュー",
    "restaurant_table_td6": "朝食",
    "restaurant_table_td7": "昼食 & 夕食",
    "restaurant_table_td8": "規模",
    "restaurant_table_td9": "68席/最大120席（人員超過の場合には別途お問い合わせください）",
    "restaurant_table_td10": "お問い合せ",
    "restaurant_table_td11": "+82-64-793-5030"
  }
}
</i18n>
